import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import React from 'react';

interface BenefitInfoPanelProps {
  backgroundImage: string;
  title: string;
  description: string;
  primaryButtonLabel: string;
  onPrimaryClick: () => void;
  secondaryButtonLabel?: string;
  onSecondaryClick?: () => void;
}

const BenefitInfoPanel: React.FC<BenefitInfoPanelProps> = ({
  backgroundImage,
  title,
  description,
  primaryButtonLabel,
  onPrimaryClick,
  secondaryButtonLabel,
  onSecondaryClick,
}) => (
  <Box
    sx={{
      width: '100%',
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        width: '100%',
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 500, width: '100%', borderRadius: 2 }}>
        <Stack spacing={2}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: 'bold',
            }}
          >
            {title}
          </Typography>
          <Typography color="textSecondary" variant="body1" gutterBottom>
            {description}
          </Typography>
          <Button variant="contained" fullWidth onClick={onPrimaryClick}>
            {primaryButtonLabel}
          </Button>
          {secondaryButtonLabel && onSecondaryClick && (
            <Button variant="outlined" sx={{ py: 1.5 }} fullWidth onClick={onSecondaryClick}>
              {secondaryButtonLabel}
            </Button>
          )}
        </Stack>
      </Paper>
    </Box>
  </Box>
);

export default BenefitInfoPanel;
